<template>
  <header class="container-fluid relative max-h-[40vh] md:max-h-[722px]">
    <slot></slot>
    <section class="slider">
      <Swiper class="swiper-wrapper" :loop="true" :autoplay="{ delay: 2500, disableOnInteraction: false }" space-between="0" navigation :modules="[Navigation]">
        <SwiperSlide class="swiper-slide" v-for="banner in banners" :key="banner" style="overflow: hidden;">
          <img class="object-cover h-full w-screen" :imgproxy-src="banner" alt />
        </SwiperSlide>
      </Swiper>
    </section>
  </header>
</template>

<script setup lang="ts">
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

const banners = ["https://leonhotel.ru/rsz_1arm_9615.jpg", "https://leonhotel.ru/rsz_dsc04103.jpg"];

// export default {
//   name: "Header",
//   data() {
//     return {
//       banners: ["/rsz_1arm_9615.jpg", "/rsz_dsc04103.jpg"],
//       swiperOption: {
//         spaceBetween: 0,
//         centeredSlides: true,
//         loop: true,
//         autoplay: {
//           delay: 2500,
//           disableOnInteraction: false
//         },
//         pagination: {
//           el: ".swiper-pagination",
//           clickable: true
//         },
//         navigation: {
//           nextEl: ".swiper-button-next",
//           prevEl: ".swiper-button-prev"
//         }
//       }
//     };
//   }
// };
</script>

<style scoped>
header {
  height: 83vh;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: none;
  display: flex;
  align-items: flex-start;
  align-content: space-between;
  padding-top: 30px;
}

header .slider {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1;
  overflow: hidden;
}
</style>

<style>
.swiper-container {
  height: 100%;
}


.swiper-pagination-bullet {
  background-color: #d9ccaf;
  opacity: 1;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  transition: 0.6s;
  outline: none !important;
}

.swiper-pagination-bullet.swiper-pagination-bullet-active {
  background-color: white;
}

.swiper-slide {
  height: auto;
  width: auto;
  min-height: 100%;
  min-width: 100%;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: none;
}
</style>
